import React from 'react';
import {
  NavigationDayType,
  PostingPlanMobileNavigationView,
  PostingPlanMobileNavigationViewProps
} from './PostingPlanMobileNavigation.view';
import { PostingPlanHelpers } from '../postingPlanHelpers';

export type PostingPlanMobileNavigationControllerProps = Omit<PostingPlanMobileNavigationViewProps, 'dayNavigation'> & {
  // extend your PostingPlanMobileNavigationViewProps
};

export const PostingPlanMobileNavigationController = (
  props: PostingPlanMobileNavigationControllerProps
): JSX.Element => {
  const dayNavigation: NavigationDayType[] = PostingPlanHelpers.getSortedDayNames(props.startDayWeek).map(value => ({
    day: value,
    displayValue: value.charAt(0)
  }));

  const viewProps: PostingPlanMobileNavigationViewProps = { ...props, dayNavigation };
  return <PostingPlanMobileNavigationView {...viewProps} />;
};
